module.exports = __webpack_public_path__ + "static/media/undo-black-36-dp.90e26a47.svg";